import {useState, useRef, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

//Selectors
import {
  roomInfoMapSelector,
  searchHotelDetailsSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

//utils
import {gaConfig} from '@stencil/hotels-config';
import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';
import pluralise from '@stencil/hotels-utils/src/common-pluralise-if-necessary';

//Styles
import * as S from './RoomTypeDropdown.styles';

// Omniture Imports
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

const {DetailsGAClickEventActions} = gaConfig;

const RoomTypeDropdown = ({rooms = [], colummnNames}) => {
  const wrapperRef = useRef(null);

  const [showRoomTypeDropdown, setShowRoomTypeDropdown] = useState(false);
  const [selected, setSelected] = useState(0);
  const roomInfoMap = useSelector(roomInfoMapSelector);
  const searchRoomHotelDetails = useSelector(searchHotelDetailsSelector);

  const dispatch = useDispatch();

  const totalRoomType = rooms?.length;

  const handleClickOutside = event => {
    if (showRoomTypeDropdown) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowRoomTypeDropdown(false);
      }
    }
    return;
  };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showRoomTypeDropdown]);

  const handleRoomScroll = id => {
    var element = document.getElementById(id);

    const offset = 306;

    const bodyRect = document.body.getBoundingClientRect().top;

    const elementRect = element.getBoundingClientRect().top;

    const elementPosition = elementRect - bodyRect;

    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,

      behavior: 'smooth',
    });

    // setToggleDropdown(false);
  };

  const goToRoom = (roomId, index) => {
    // let str = "[id='" + roomId + 'upselldd' + "']";
    // scrollToEl(str);
    let str = roomId + 'upselldd';

    handleRoomScroll(str);
    setShowRoomTypeDropdown(!showRoomTypeDropdown);
    setSelected(index);
  };

  return (
    <S.RoomTypesBtn
      ref={wrapperRef}
      onClick={() => {
        dispatch(
          omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
            cta: {
              name: `${DetailsPageComponents.RoomTypeDropDown}_${detailsClick.roomTypeDropDown.room_types_pill}`,
              type: omnitureConfig.ctaType.Button,
              componentName: DetailsPageComponents.RoomTypeDropDown,
              destination: '',
            },
          }),
        );
        setShowRoomTypeDropdown(!showRoomTypeDropdown);
      }}
      active={showRoomTypeDropdown}
    >
      {/* // @Note setting bydefault 2 as for getting pluralised text */}
      {totalRoomType} {pluralise(colummnNames.type, 2)}
      {showRoomTypeDropdown && (
        <S.RoomTypeDropdown>
          {rooms.map((room, index) => {
            const roomCode = room.roomCode;

            const roomFlavorsDataForThisRoom = room.ratePlans?.[0];
            const staticDataForThisRoom = roomInfoMap[roomCode];

            const {showPrice} = getSlashAndShowPriceCg(roomFlavorsDataForThisRoom?.tariffs?.[0]);

            return (
              <li
                key={index}
                onClick={e => {
                  e.stopPropagation();
                  dispatch(
                    omnitureThunk(
                      omnitureConfig.pages.DetailsUnif,
                      omnitureConfig.events.ctaClick,
                      {
                        cta: {
                          name: `${DetailsPageComponents.RoomTypeDropDown}_${
                            detailsClick.roomTypeDropDown.rt_pill_room_selected
                          }_${index + 1}`,
                          type: omnitureConfig.ctaType.Button,
                          componentName: DetailsPageComponents.RoomTypeDropDown,
                          destination: '',
                        },
                      },
                    ),
                  );
                  goToRoom(roomCode, index);
                  setSelected(index);
                }}
                className="makeFlex spaceBetween"
              >
                {selected === index && <S.LeftActiveBar />}
                <div>
                  <S.RoomTypeNameWrapper>
                    <S.RoomType className={`${selected === index ? 'active' : ''}`}>
                      {room?.roomName}
                    </S.RoomType>
                    {roomFlavorsDataForThisRoom?.packageRateAvailable &&
                    searchRoomHotelDetails?.packageTagUrl ? (
                      <S.PackageTag>
                        <img src={searchRoomHotelDetails?.packageTagUrl} alt="package-icon-img" />
                      </S.PackageTag>
                    ) : null}
                  </S.RoomTypeNameWrapper>

                  <S.RoomTypePriceInfo>
                    Starts at ₹{showPrice}
                    {staticDataForThisRoom?.roomSize ? ' | ' + staticDataForThisRoom?.roomSize : ''}
                  </S.RoomTypePriceInfo>
                </div>
              </li>
            );
          })}
        </S.RoomTypeDropdown>
      )}
    </S.RoomTypesBtn>
  );
};

export default RoomTypeDropdown;
